/**
 * Connections Service - fetches friends/family for "Show friends' reviews first"
 * Uses authToken or mango_token; returns [] if no auth or API unavailable.
 */
import { API_ENDPOINTS } from '../config/api';
import safeStorage from '../utils/safeStorage';

const getAuthToken = () => {
  try {
    return (
      localStorage.getItem('authToken') ||
      localStorage.getItem('mango_token') ||
      safeStorage.getItem('authToken', null) ||
      safeStorage.getItem('mango_token', null)
    );
  } catch {
    return null;
  }
};

/**
 * Fetch current user's connections (friends, family, following)
 * @returns {Promise<string[]>} Array of friend userIds
 */
export const getConnections = async () => {
  const token = getAuthToken();
  if (!token) return [];

  try {
    const res = await fetch(API_ENDPOINTS.connections, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return [];
    const data = await res.json();
    const list = data?.data ?? [];
    return list.map((c) => c.userId).filter(Boolean);
  } catch {
    return [];
  }
};

const connectionsService = { getConnections };
export default connectionsService;
